export default __webpack_public_path__ + "static/media/A.I.5654749d.svg";